import classNames from 'classnames/bind'

import styles from './MasterLayout.module.scss'
import { drawerWidth, Navbar } from './Navbar'
import { styled } from '@mui/material'
import { Suspense } from 'react'
import { currentTheme, drawerSetting, setDrawerSetting } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { selectAuth } from '../../redux/features/auth/authSlice'
import { MainProps } from './MasterLayout.component.model'
import { ReactNodeChilrenProps } from '~/components/GlobalStyles'
import { Outlet } from 'react-router'
import { EFLoading } from '~/components'
import { useMobileView } from '~/hooks/useMobileView'
import { useDispatch } from 'react-redux'

const cx = classNames.bind(styles)

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })<MainProps>(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: 0,
    overflow: 'hidden',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginTop: 'max(6vh, 40px)',
    [theme.breakpoints.up(800)]: {
      marginLeft: `calc(6rem)`,
      ...(open && {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: `calc(${drawerWidth}rem)`
      })
    }
  })
)

export const MasterLayout = ({ children }: ReactNodeChilrenProps) => {
  const theme = useAppSelector(currentTheme)
  const { isShowDrawer } = useAppSelector(drawerSetting)
  const isMobile = useMobileView()
  const dispatch = useDispatch()
  const user = useAppSelector(selectAuth)

  return (
    <div className={cx('master-layout', theme)}>
      <Navbar key={user.userName + 'nav'} />
      <Main
        open={isShowDrawer}
        className={cx('app-container', theme)}
      >
        {isShowDrawer && isMobile && (
          <button
            type='button'
            onClick={() => dispatch(setDrawerSetting({ isShowDrawer: false }))}
            className={cx('backdrop')}
            aria-label='Close drawer'
            tabIndex={0}
          />
        )}
        <div className={cx('content')}>
          <div className={cx('body', theme)}>{children}</div>
        </div>
      </Main>
    </div>
  )
}
export const MasterLayoutOutlet = () => {
  const theme = useAppSelector(currentTheme)
  const { isShowDrawer } = useAppSelector(drawerSetting)
  const isMobile = useMobileView()
  const dispatch = useDispatch()
  const user = useAppSelector(selectAuth)

  return (
    <div className={cx('master-layout', theme)}>
      <Navbar key={user.userName + 'nav'} />
      <Main
        open={isShowDrawer}
        className={cx('app-container', theme)}
      >
        {isShowDrawer && isMobile && (
          <button
            type='button'
            onClick={() => dispatch(setDrawerSetting({ isShowDrawer: false }))}
            className={cx('backdrop')}
            aria-label='Close drawer'
            tabIndex={0}
          />
        )}
        <div className={cx('content')}>
          <div className={cx('body', theme)}>
            <Suspense fallback={<EFLoading isFixed />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </Main>
    </div>
  )
}
